export const FIELD_NAME_PREFILL_OPTIONS = [
  'dealer.name',
  'dealer.address',
  'dealer.city',
  'dealer.phone',
  'dealer.state',
  'dealer.zip',

  'car.id',
  'car.stock',
  'car.year + " " + car.make + " " + car.model',
  'car.year',
  'car.make',
  'car.model',
  'car.trim',
  'car.mileage',
  'car.humanColor',

  'deal.id',
  'deal.updatedAt|fullDate',
  'deal.source',
  'deal.applicant.firstName',
  'deal.applicant.middleName',
  'deal.applicant.lastName',
  'deal.applicant.firstName + " " + deal.applicant.lastName',
  'deal.applicant.firstName + " " + deal.applicant.middleName + " " + deal.applicant.lastName',
  'deal.applicant.socialSec',
  'deal.applicant.birthday',
  'deal.applicant.email',
  'deal.applicant.phone',
  'deal.applicant.homePhone',
  'deal.applicant.driverLicenseNumber',
  'deal.applicant.driverLicenseState',
  'deal.applicant.address',
  'deal.applicant.city',
  'deal.applicant.state',
  'deal.applicant.zip',
  'deal.applicant.yearsAtAddress',
  'deal.applicant.monthsAtAddress',
  'deal.applicant.rentType',
  'deal.applicant.mortgageLease',
  'deal.applicant.prevAddress',
  'deal.applicant.prevCity',
  'deal.applicant.prevState',
  'deal.applicant.prevZip',
  'deal.applicant.prevYearsAtAddress',
  'deal.applicant.prevMonthsAtAddress',
  'deal.applicant.employmentStatus',
  'deal.applicant.jobTitle',
  'deal.applicant.companyName',
  'deal.applicant.companyAddress',
  'deal.applicant.companyCity',
  'deal.applicant.companyState',
  'deal.applicant.companyZip',
  'deal.applicant.companyStart',
  'deal.applicant.employerPhone',
  'deal.applicant.monthlySalary',
  'deal.applicant.otherIncome',
  'deal.applicant.otherIncomeSource',
  'deal.applicant.monthlySalary + deal.applicant.otherIncome',
  'deal.applicant.prevJobTitle',
  'deal.applicant.prevCompanyName',
  'deal.applicant.prevCompanyAddress',
  'deal.applicant.prevCompanyCity',
  'deal.applicant.prevCompanyState',
  'deal.applicant.prevCompanyZip',
  'deal.applicant.prevCompanyPhone',
  'deal.applicant.prevYearsAtCompany',
  'deal.applicant.prevMonthsAtCompany',
  'deal.applicant.references[0].type',
  'deal.applicant.references[0].firstName',
  'deal.applicant.references[0].lastName',
  'deal.applicant.references[0].phone',
  'deal.applicant.references[0].address',
  'deal.applicant.references[0].city',
  'deal.applicant.references[0].state',
  'deal.applicant.references[0].zip',
  'deal.applicant.references[1].type',
  'deal.applicant.references[1].firstName',
  'deal.applicant.references[1].lastName',
  'deal.applicant.references[1].phone',
  'deal.applicant.references[1].address',
  'deal.applicant.references[1].city',
  'deal.applicant.references[1].state',
  'deal.applicant.references[1].zip',
  'deal.applicant.references[2].type',
  'deal.applicant.references[2].firstName',
  'deal.applicant.references[2].lastName',
  'deal.applicant.references[2].phone',
  'deal.applicant.references[2].address',
  'deal.applicant.references[2].city',
  'deal.applicant.references[2].state',
  'deal.applicant.references[2].zip',
  'deal.coapplicant.firstName',
  'deal.coapplicant.middleName',
  'deal.coapplicant.lastName',
  'deal.coapplicant.firstName + " " + deal.coapplicant.lastName',
  'deal.coapplicant.firstName + " " + deal.coapplicant.middleName + " " + deal.coapplicant.lastName',
  'deal.coapplicant.socialSec',
  'deal.coapplicant.birthday',
  'deal.coapplicant.email',
  'deal.coapplicant.phone',
  'deal.coapplicant.driverLicenseNumber',
  'deal.coapplicant.driverLicenseState',
  'deal.coapplicant.address',
  'deal.coapplicant.city',
  'deal.coapplicant.state',
  'deal.coapplicant.zip',
  'deal.coapplicant.yearsAtAddress',
  'deal.coapplicant.monthsAtAddress',
  'deal.coapplicant.rentType',
  'deal.coapplicant.mortgageLease',
  'deal.coapplicant.prevAddress',
  'deal.coapplicant.prevCity',
  'deal.coapplicant.prevState',
  'deal.coapplicant.prevZip',
  'deal.coapplicant.prevYearsAtAddress',
  'deal.coapplicant.prevMonthsAtAddress',
  'deal.coapplicant.employmentStatus',
  'deal.coapplicant.jobTitle',
  'deal.coapplicant.companyName',
  'deal.coapplicant.companyAddress',
  'deal.coapplicant.companyCity',
  'deal.coapplicant.companyState',
  'deal.coapplicant.companyZip',
  'deal.coapplicant.companyStart',
  'deal.coapplicant.employerPhone',
  'deal.coapplicant.monthlySalary',
  'deal.coapplicant.otherIncome',
  'deal.coapplicant.otherIncomeSource',
  'deal.coapplicant.monthlySalary + deal.coapplicant.otherIncome',
  'deal.coapplicant.prevJobTitle',
  'deal.coapplicant.prevCompanyName',
  'deal.coapplicant.prevCompanyAddress',
  'deal.coapplicant.prevCompanyCity',
  'deal.coapplicant.prevCompanyState',
  'deal.coapplicant.prevCompanyZip',
  'deal.coapplicant.prevCompanyPhone',
  'deal.coapplicant.prevYearsAtCompany',
  'deal.coapplicant.prevMonthsAtCompany',
  'deal.coapplicant.references[0].type',
  'deal.coapplicant.references[0].firstName',
  'deal.coapplicant.references[0].lastName',
  'deal.coapplicant.references[0].phone',
  'deal.coapplicant.references[0].address',
  'deal.coapplicant.references[0].city',
  'deal.coapplicant.references[0].state',
  'deal.coapplicant.references[0].zip',
  'deal.coapplicant.references[1].type',
  'deal.coapplicant.references[1].firstName',
  'deal.coapplicant.references[1].lastName',
  'deal.coapplicant.references[1].phone',
  'deal.coapplicant.references[1].address',
  'deal.coapplicant.references[1].city',
  'deal.coapplicant.references[1].state',
  'deal.coapplicant.references[1].zip',
  'deal.coapplicant.references[2].type',
  'deal.coapplicant.references[2].firstName',
  'deal.coapplicant.references[2].lastName',
  'deal.coapplicant.references[2].phone',
  'deal.coapplicant.references[2].address',
  'deal.coapplicant.references[2].city',
  'deal.coapplicant.references[2].state',
  'deal.coapplicant.references[2].zip',
  'deal.selectedOffer.tradeValue',
  'deal.tradeIns[0].id',
  'deal.tradeIns[0].year.name',
  'deal.tradeIns[0].make.name',
  'deal.tradeIns[0].model.name',
  'deal.tradeIns[0].trim.name',
  'deal.tradeIns[0].year.name + " " + deal.tradeIns[0].make.name + " " + deal.tradeIns[0].model.name',
  'deal.tradeIns[0].mileage',
  'deal.tradeIns[0].payOff',
  'deal.tradeIns[0].tradeValue',
  'deal.tradeIns[0].zip',
  'deal.tradeIns[1].id',
  'deal.tradeIns[1].year.name',
  'deal.tradeIns[1].make.name',
  'deal.tradeIns[1].model.name',
  'deal.tradeIns[1].trim.name',
  'deal.tradeIns[1].year.name + " " + deal.tradeIns[1].make.name + " " + deal.tradeIns[1].model.name',
  'deal.tradeIns[1].mileage',
  'deal.tradeIns[1].payOff',
  'deal.tradeIns[1].tradeValue',
  'deal.tradeIns[1].zip',
  'deal.tradeIns[2].id',
  'deal.tradeIns[2].year.name',
  'deal.tradeIns[2].make.name',
  'deal.tradeIns[2].model.name',
  'deal.tradeIns[2].trim.name',
  'deal.tradeIns[2].year.name + " " + deal.tradeIns[2].make.name + " " + deal.tradeIns[2].model.name',
  'deal.tradeIns[2].mileage',
  'deal.tradeIns[2].payOff',
  'deal.tradeIns[2].tradeValue',
  'deal.tradeIns[2].zip',

  'user.firstName',
  'user.lastName',
  'user.firstName + " " + user.lastName',
];
